
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/context-hub/guardrails",
      function () {
        return require("private-next-pages/context-hub/guardrails.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/context-hub/guardrails"])
      });
    }
  